var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DashboardWidgetLineSmooth',{staticClass:"widget-cash-flow-line",attrs:{"title":"Cash Flow","dataY":_vm.dataY,"dataX":_vm.dataX,"legend":"Cash Flow"}})}
var staticRenderFns = []

export { render, staticRenderFns }